export default __webpack_public_path__ + "static/media/nUSD-LP.ff00948f.png";